module.exports = __webpack_public_path__ + "8b04969a2f383342d969355e8e1a8a92.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-right-7.png
// module id = 3049
// module chunks = 0